// extracted by mini-css-extract-plugin
export default {"button":"VersionBack_button__2idns","image":"VersionBack_image__4F661"};